<template><section><h2>Basic Bar Chart 基础条形图</h2>
<block-demo tip="1" source="const data = [
  { value: 6100, label: &quot;TOP1&quot; },
  { value: 5200, label: &quot;TOP2&quot; },
  { value: 4400, label: &quot;TOP3&quot; },
  { value: 3700, label: &quot;TOP4&quot; },
  { value: 2800, label: &quot;TOP5&quot; },
  { value: 2000, label: &quot;TOP6&quot; },
  { value: 1300, label: &quot;TOP7&quot; },
  { value: 400, label: &quot;TOP8&quot; },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const bar = new Bar({
  transpose: true,
  barWidth: 18,
  animation: {
    duration: 1000,
    easing: &quot;elasticOut&quot;,
  },
})

const tooltip = new Tooltip()
const axisBottom = new Axis().style(&quot;scale&quot;, false)
const axisLeft = new Axis({
  orient: &quot;left&quot;,
}).style(&quot;grid&quot;, false)
chart.append([bar, tooltip, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">6100</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP1"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">5200</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP2"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">4400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP3"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3700</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP4"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2800</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP5"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2000</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP6"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1300</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP7"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP8"</span> },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">transpose</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">barWidth</span>: <span class="hljs-number">18</span>,
  <span class="hljs-attr">animation</span>: {
    <span class="hljs-attr">duration</span>: <span class="hljs-number">1000</span>,
    <span class="hljs-attr">easing</span>: <span class="hljs-string">"elasticOut"</span>,
  },
})

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"scale"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({
  <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span>,
}).style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>